import { createAction, props } from '@ngrx/store';

export const getFerienReportStarted = createAction('ZEIT::GET_FILTERED_FERIEN_REPORT_START', props<{ jahr: number, mitarbeiter: number[] }>());
export const getFerienReportSucceeded = createAction('ZEIT::GET_FILTERED_FERIEN_REPORT_SUCCEEDED');
export const getFerienReportFailed = createAction('ZEIT::GET_FILTERED_FERIEN_REPORT_FAILED', props<{ error: Error }>());
